module.exports = __webpack_public_path__ + "img/illustrate01.bcad9315.png";